import type { TrigKey } from './keys';

export const en: Record<TrigKey, string> = {
  'app.eyebrow': 'Math · Trigonometry',
  'panel.experiment': 'Experiment',
  'panel.params': 'Parameters',
  'panel.scene': 'Choose an experiment',
  'view.reset': 'Reset view',
  'experiment.right-triangle.label': 'Right triangle',
  'experiment.unit-circle.label': 'Unit circle',
  'experiment.wave-studio.label': 'Wave studio',
  'experiment.identity-playground.label': 'Identities',
  'experiment.triangle-solver.label': 'Triangle solver',
  'experiment.circular-polar.label': 'Circular & polar',
  'hint.line1': 'Drag points and move sliders.',
  'hint.line2': 'Educational content lives in the geometry, not the text.',
  'hint.line3': 'Scroll or pinch to zoom, drag to pan, double-click to reset.',
  'rt.angle.a': 'Angle A',
  'rt.angle.b': 'Angle B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Radians',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': 'Snap to 30°/45°/60°',
  'uc.units': 'Units',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'Show ASTC',
  'uc.snap.common': 'Snap to common angles',
  'uc.angle.value': '∠',
  'uc.units.deg': 'deg',
  'uc.units.rad': 'rad',
  'uc.units.both': 'deg+rad',
  'ws.fn': 'Function',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — Amplitude',
  'ws.frequency': 'B — Frequency',
  'ws.phase': 'C — Phase shift',
  'ws.shift': 'D — Vertical shift',
  'ws.rform.toggle': 'R-form derivation',
  'ws.rform.a': 'a (sin coeff)',
  'ws.rform.b': 'b (cos coeff)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'Reset',
  'ws.base': 'Show base curve',
  'ws.functions': 'Functions',
  'ws.add': 'Add function',
  'ws.remove': 'Remove function',
  'ws.visible': 'Show or hide function',
  'ws.showParams': 'Show parameters',
  'ip.id.pythagorean': 'Pythagorean',
  'ip.id.reciprocal': 'Reciprocal',
  'ip.id.quotient': 'Quotient',
  'ip.id.sum': 'Sum',
  'ip.id.difference': 'Difference',
  'ip.id.double': 'Double-angle',
  'ip.id.half': 'Half-angle',
  'ip.play': 'Play',
  'ip.pause': 'Pause',
  'ip.step': 'Step',
  'ip.reset': 'Reset',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'Coming in v2 — this proof needs a more elaborate construction.',
  'ts.area': 'Area',
  'ts.sineRule': 'Sine rule',
  'ts.cosineRule': 'Cosine rule',
  'ts.ambiguous.toggle': 'Show ghost triangle when ambiguous',
  'ts.reset': 'Reset to equilateral',
  'ts.snap.integers': 'Snap to integers',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Sides',
  'ts.section.angles': 'Angles',
  'ts.section.sineRule': 'Sine rule',
  'ts.section.cosineRule': 'Cosine rule',
  'ts.section.area': 'Area',
  'cp.omega': 'Angular velocity',
  'cp.plot.y': 'Plot y (sin)',
  'cp.plot.x': 'Plot x (cos)',
  'cp.polar.label': 'Polar figure',
  'cp.polar.circle': 'Circle (r = 1)',
  'cp.polar.rose': 'Rose (r = sin 3θ)',
  'cp.polar.cardioid': 'Cardioid (r = 1 + cos θ)',
  'cp.polar.limacon': 'Limaçon (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Small-angle approx (sin x ≈ x)',
  'cp.play': 'Play',
  'cp.pause': 'Pause',
  'cp.reset': 'Reset',
  'cp.step': 'Step π/12',
};
